import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/stdtrtest/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/stdtrtest/labels')
  }
}



// WEBPACK FOOTER //
// ./src/api/stdtrtest/index.js